import React, { useContext } from "react";
import { FcGoogle } from "react-icons/fc";
import Wosenderabout from "../../../../images/LandingPageImage/audience_tracking_1x.webp";
import "../designcss/Wosenderaboutenable.css";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FAQ from "./FAQ"
import GetStartedNow from './GetStartedNow'
import Audiencegrowsmartercard from './Audiencegrowsmartercard'
import Audiencewhatwedocard from './Audiencewhatwedocard'
import { Link } from "react-router-dom";
import MyContext from "../../../../MyContext";

const AudienceTargating = () => {
  const { openFreeTrialModal } = useContext(MyContext)
  return (
    <>
    <Navbar/>
      <div className="about-hero-container">
        <div className="leftsidecontent">
          <span className="businessgrow">Connect with the Right Customers</span>
          <span className="usingwhatsapp">on WhatsApp</span>
          {/* <span className="marketingservice">and Convert Customers</span> */}

          <p className="paracontent">
            In today’s digital-first world, reaching everyone is no longer the
            goal reaching the right audience is. Smart audience segmentation
            allows businesses to send relevant, personalized messages to
            specific customer groups, improving engagement, boosting
            conversions, and maximizing ROI.
          </p>

          <div className="buttons">
            <Link to="/login" className="text-decoration-none">
             <button className="demobtn">
              <FcGoogle /> Start With Google
            </button>
            </Link>
           
            <button onClick={openFreeTrialModal} className="demobtn">Book a Demo</button>
          </div>
        </div>

        <div className="rightsideimg">
          <img src={Wosenderabout} alt="" className="homescreen" />
        </div>
      </div>

    <Audiencegrowsmartercard/>
    <Audiencewhatwedocard/>
    <FAQ/>
    <GetStartedNow/>

      <Footer/>
    </>
  );
};

export default AudienceTargating;
